import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Note shown whenever the free serviceaftale is activated (compatible charger / new charger).
 * The customer must cancel any existing service agreement with their current provider themselves —
 * it's the only thing we cannot do automatically.
 */
export default function ServiceCancellationNote({ className = '' }) {
  return (
    <div className={`mt-2 rounded-xl px-3 py-2.5 border border-[#D4A62A]/40 bg-[#FBF6E7] flex items-start gap-2 ${className}`}>
      <AlertCircle className="w-3.5 h-3.5 text-[#B58716] flex-shrink-0 mt-0.5" />
      <p className="text-[11px] text-[#6b5e3a] leading-relaxed">
        <strong className="text-[#5a4d2a]">Husk:</strong> Har du allerede en serviceaftale på din ladeboks hos en anden udbyder,
        skal du selv opsige den. Det er det eneste, vi ikke kan klare automatisk for dig.
      </p>
    </div>
  );
}